/* 02 · Best-sellers (Shopify : assets/obaia-section-best-sellers.js)
   Carrousel : flèches (une carte à la fois), barre de progression, flèches grisées aux extrémités. */
OBAIA.section('best-sellers', {
  init: function (root) {
    OBAIA.$$('[data-carousel]', root).forEach(function (root) {
      var $ = OBAIA.$;
      var track = $('[data-carousel-track]', root), thumb = $('[data-carousel-thumb]', root);
      var prev = $('[data-carousel-prev]', root), next = $('[data-carousel-next]', root);
      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : 316;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        thumb.style.setProperty('--w', Math.min(1, track.clientWidth / track.scrollWidth).toFixed(4));
        thumb.style.setProperty('--p', (max > 0 ? track.scrollLeft / max : 0).toFixed(4));
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      var smooth = OBAIA.reduce ? 'auto' : 'smooth';
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: smooth }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: smooth }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
});
